import { render } from "./InsightsFeed.vue?vue&type=template&id=0281eb4a"
import script from "./InsightsFeed.vue?vue&type=script&lang=js"
export * from "./InsightsFeed.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__